<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { Btn, BtnColor, BtnSize, BtnVariant } from '~/components/btn';
import { useOrganizationStore } from '~/store/organization';

const props = defineProps<{
  imageUrl: string | null;
}>();

const organizationStore = useOrganizationStore();
const { nonNullableOrganization } = storeToRefs(organizationStore);

const { t } = useI18n();
</script>

<template>
  <div class="md:relative md:h-screen">
    <img v-if="props.imageUrl" :src="props.imageUrl" class="w-full md:h-full" />

    <div
      class="md:absolute md:inset-0 md:flex md:items-center md:justify-center"
    >
      <div
        class="md:bg-surface md:rounded-2xl pb-10 px-10 md:px-14 md:max-h-[90%] md:max-w-[930px] md:overflow-y-auto text-center"
      >
        <div class="pt-5 md:pt-12 font-bold text-xl md:text-5xl">
          {{ t('title') }}
        </div>

        <div class="pt-10">
          {{
            t('description', { organizationName: nonNullableOrganization.name })
          }}
        </div>

        <div class="pt-10">
          <Btn
            :variant="BtnVariant.FILLED"
            :color="BtnColor.PRIMARY"
            :size="BtnSize.LG"
            to="/"
          >
            {{ t('return-to-homepage') }}
          </Btn>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n lang="json">
{
  "en-US": {
    "title": "You're Done!",
    "description": "Thank you for providing information for your Co-op Campaign with {organizationName}! We are working on building your campaign and look forward to speaking with you.",
    "return-to-homepage": "Return to Homepage"
  },
  "fr-FR": {},
  "es-ES": {},
  "pt-PT": {},
  "de-DE": {}
}
</i18n>
